/* global G */
import { curry } from 'lib/util'

/**
 * Message Get Event Handler
 *
 * Returns a list of the current messages or a specific message if `event.key` or
 * `event.detail.key` is present.
 *
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {Gaia.PlatformEvent} event        information about the note
 * @returns {Promise<unknown>}
 */
const get = async (module, component, event) => {
  const { key = null } = event?.detail || event || {}
  const eventBus = module[G.ADAPTER][G.EVENTS]

  return new Promise((resolve) => {
    eventBus.add(eventBus.type(G.MESSAGE, G.DONE), ({ detail }) => {
      const messages = detail[G.DATA]

      resolve(key
        ? messages.find(message => message.key === key)
        : messages)
    }, { once: true })
    eventBus.dispatch(eventBus.type(G.MESSAGE, G.CACHE))
  })
}

export default curry(get)
